import React from "react";
import { Col, Form } from "react-bootstrap";
import {
  Control,
  Controller,
  UseFieldArrayRemove,
  useWatch,
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ICustomer } from "../../shared/interfaces/customer/ICustomer";
import { CustomerService } from "./service";
import { ErrorToast } from "../../shared/toasters/toasters";

interface IProps {
  index: number;
  key: number;
  remove: UseFieldArrayRemove;
  control: Control<ICustomer>;
}

const CustomerPersonForm = ({ index, key, remove, control }: IProps) => {
  const { t } = useTranslation();
  const contactPerson = useWatch({
    control,
    name: `contactPersons.${index}`,
  });

  const handleDelete = (id: number) => {
    console.log(id, "sanja");
    CustomerService.deleteContactPerson(id)
      .then(() => {
        remove(index);
      })
      .catch(ErrorToast);
  };
  return (
    <React.Fragment key={key}>
      <Col md={3} className={"mb-3"}>
        <Form.Label>{t("general.firstName")}</Form.Label>
        <Controller
          control={control}
          name={`contactPersons.${index}.firstName`}
          render={({ field: { onChange, value }, fieldState }) => (
            <>
              <Form.Control
                onChange={onChange}
                value={value}
                isInvalid={!!fieldState.error}
                placeholder={t("general.enterFirstName")}
              />
              <Form.Control.Feedback type="invalid">
                {t(fieldState.error?.message as string)}
              </Form.Control.Feedback>
            </>
          )}
        />
      </Col>
      <Col md={2} className={"mb-3"}>
        <Form.Label className="required">{t("general.lastName")}</Form.Label>
        <Controller
          control={control}
          name={`contactPersons.${index}.lastName`}
          render={({ field: { onChange, value }, fieldState }) => (
            <>
              <Form.Control
                onChange={onChange}
                value={value}
                isInvalid={!!fieldState.error}
                placeholder={t("general.enterLastName")}
              />
              <Form.Control.Feedback type="invalid">
                {t(fieldState.error?.message as string)}
              </Form.Control.Feedback>
            </>
          )}
        />
      </Col>
      <Col md={2} className={"mb-3"}>
        <Form.Label>{t("general.surname")}</Form.Label>
        <Controller
          control={control}
          name={`contactPersons.${index}.surname`}
          render={({ field: { onChange, value }, fieldState }) => (
            <>
              <Form.Control
                onChange={onChange}
                value={value ?? ""}
                isInvalid={!!fieldState.error}
                placeholder={t("general.enterSurname")}
              />
              <Form.Control.Feedback type="invalid">
                {t(fieldState.error?.message as string)}
              </Form.Control.Feedback>
            </>
          )}
        />
      </Col>
      <Col md={3} className={"mb-3"}>
        <Form.Label>{t("general.email")}</Form.Label>
        <Controller
          control={control}
          name={`contactPersons.${index}.email`}
          render={({ field: { onChange, value }, fieldState }) => (
            <>
              <Form.Control
                onChange={onChange}
                value={value}
                isInvalid={!!fieldState.error}
                type={"email"}
                placeholder={t("general.enterEmail")}
              />
              <Form.Control.Feedback type="invalid">
                {t(fieldState.error?.message as string)}
              </Form.Control.Feedback>
            </>
          )}
        />
      </Col>
      <Col md={2} className={"d-flex justify-content-between mb-3"}>
        <Form.Group>
          <Form.Label>{t("general.phone")}</Form.Label>
          <Controller
            control={control}
            name={`contactPersons.${index}.mobile`}
            render={({ field: { onChange, value }, fieldState }) => (
              <>
                <Form.Control
                  onChange={onChange}
                  value={value}
                  isInvalid={!!fieldState.error}
                  type={"phone"}
                  placeholder={t("general.enterPhone")}
                />
                <Form.Control.Feedback type="invalid">
                  {t(fieldState.error?.message as string)}
                </Form.Control.Feedback>
              </>
            )}
          />
        </Form.Group>
        <button
          onClick={() =>
            !!contactPerson?.id
              ? handleDelete(contactPerson?.id)
              : remove(index)
          }
          type={"button"}
          className="btn btn-icon btn-sm btn-danger mt-4"
        >
          <i className="ti ti-trash fs-4"></i>
        </button>
      </Col>
    </React.Fragment>
  );
};

export default CustomerPersonForm;
